import styled, { css } from 'styled-components';
import media from 'styled-media-query';
const ParagraphModifiers = {
    large: (theme) => css `
    ${media.lessThan('medium') `
        font-size: ${theme.font.size.sm};
        line-height: ${theme.spacing.stack.xxs};
    `}
    ${media.between('medium', 'large') `
        font-size: ${theme.font.size.sm};
        line-height: ${theme.spacing.stack.xxs};
    `}
    ${media.greaterThan('medium') `
        font-size:${theme.font.size.sm};
        line-height: ${theme.spacing.stack.xxs};
    `}
  `,
    regular: (theme) => css `
    ${media.lessThan('medium') `
        font-size: ${theme.font.size.sm};
        line-height: ${theme.spacing.stack.xxs};
    `}
    ${media.between('medium', 'large') `
        font-size: ${theme.font.size.sm};
        line-height: ${theme.spacing.stack.xxs};
    `}
        ${media.greaterThan('medium') `
        font-size:${theme.font.size.sm};
        line-height: ${theme.spacing.stack.xxs};
    `}
  `,
    small: (theme) => css `
    ${media.lessThan('medium') `
        font-size: ${theme.font.size.xs};
        line-height: 21px;
    `}
    ${media.between('medium', 'large') ` 
        font-size: ${theme.font.size.xs};
        line-height: 21px;
    `}
    ${media.greaterThan('medium') `
        font-size: ${theme.font.size.xs};
        line-height: 21px;
    `}
  `,
    bold: (theme) => css `
    font-weight: ${theme.font.weight.bold};
  `,
    semiBold: (theme) => css `
    font-weight: ${theme.font.weight.semiBold};
  `,
    normal: (theme) => css `
    font-weight: ${theme.font.weight.regular};
  `
};
export const Paragraph = styled('p') `
  ${({ theme, variant, type }) => css `
    ${ParagraphModifiers[variant](theme)}
    ${type && ParagraphModifiers[type](theme)} 
    color: ${theme.color.base.nth1};
  `}
`;
//# sourceMappingURL=Paragraph.js.map